import React, { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { userState } from "states/recoil";
import { auth, db } from "api/firebase/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Center, Spinner } from "@chakra-ui/react";

const AppInitializer = ({ children }) => {
  const setUser = useSetRecoilState(userState);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const docRef = doc(db, "users", user.email);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            const userInfo = {
              email: user.email,
              name: data.name,
              level: data.level,
              province: data.province,
              id: user.uid,
            };

            localStorage.setItem("sessionToken", "granted");
            localStorage.setItem("userInfo", JSON.stringify(userInfo));

            setUser({
              isAuthenticated: true,
              ...userInfo,
            });
          } else {
            console.warn("No user document found in Firestore.");
          }
        } catch (error) {
          console.error("Error fetching user info from Firestore:", error);
        }
      } else {
        localStorage.removeItem("sessionToken");
        localStorage.removeItem("userInfo");

        setUser({
          isAuthenticated: false,
        });
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, [setUser]);

  if (loading) {
    return (
      <Center height="100vh" bg="gray.50">
        <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
      </Center>
    );
  }

  return children;
};

export default AppInitializer;
